module.exports = __webpack_public_path__ + "profile-overlay.baa1a3e65b899154de84.png";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/profile-overlay.png
// module id = ../../../../../src/assets/img/profile-overlay.png
// module chunks = styles